<template>
    <Form>
        <h2>Set your password</h2>
        <v-form v-model="valid" @submit.prevent="submit" ref="form">
            <v-alert v-if="error" color="red" icon="mdi-alert-octagon-outline" outlined text>
                {{ error }}
            </v-alert>
            <div class="font-weight-medium">Password</div>
            <v-text-field outlined dense type="password" v-model="form.password" :rules="[$validators.isPassword]" />
            <div class="font-weight-medium">Confirm Password</div>
            <v-text-field outlined dense type="password" v-model="confirm" :rules="[(v) => v === form.password || 'not matching']" />
            <v-btn block type="submit" :disabled="!valid" :loading="loading" class="blue-btn">Save</v-btn>
        </v-form>
    </Form>
</template>

<script>
import Form from '@/pages/Form';

export default {
    components: { Form },
    data() {
        return {
            form: {
                password: '',
            },
            confirm: '',
            valid: false,
            error: '',
            loading: false,
        };
    },
    methods: {
        submit() {
            this.loading = true;
            this.$api.setPassword(this.form, (_, meta) => {
                this.loading = false;
                if (meta.code !== 200) {
                    this.error = 'Failed to set password, please try again later.';
                    return;
                }
                if (this.$route.query.next) {
                    window.location.href = this.$route.query.next;
                    return;
                }
                this.$router.go();
            });
        },
    },
};
</script>

<style scoped></style>
